(function (angular, picturefill, ToyotaConsts) {
  "use strict";

  angular.module("Toyota.Directives").directive("tyPricingImage", [
    "DebugLogger",
    function (DebugLogger) {
      function handleReject(error) {
        DebugLogger.log("tyPricingImage", error);
      }

      var controller = [
        "$scope",
        "$element",
        "$filter",
        "API",
        "$timeout",
        "cookies",
        "Tfy",
        "RangeImageApi",
        function (
          $scope,
          $element,
          $filter,
          API,
          $timeout,
          cookies,
          Tfy,
          RangeImageApi
        ) {
          var ctl = this;
          var lastPricingImageRequest = null;
          var $loadingOverlay = $element.find(".ty-loading-overlay");
          var $image = $element.find("img");
          var pricingPageMaterialCodeEventTriggered = false;

          var init = function () {
            $scope.pricingImage = $scope.pricingImage
              ? $scope.pricingImage
              : {};
            $scope.pricingImage.showImage = false;
            $scope.pricingImage.loading = false;
            $scope.pricingImage.materialCode = "";
          };

          ctl.$onInit = init;

          $scope.$on(
            "pricing-page-material-code",
            function (event, materialCodePromise) {
              loadingOverlay();

              materialCodePromise
                .then(function () {
                  if (
                    $scope.pricingImage.materialCode !== $scope.materialCode
                  ) {
                    $scope.pricingImage.materialCode = $scope.materialCode;
                    if (pricingPageMaterialCodeEventTriggered) {
                      ctl.setTfyCookie();
                    }
                    pricingPageMaterialCodeEventTriggered = true;
                    ctl.updateImage();
                  }
                })
                .catch(handleReject);
            }
          );

          ctl.updateImage = function () {
            if (!$scope.pricingImage.materialCode) {
              return;
            }

            API.cancel(lastPricingImageRequest);
            $image.off("load error");

            lastPricingImageRequest = RangeImageApi.getHeroByMaterialCode(
              $scope.pricingImage.materialCode
            ).then(
              function (result) {
                if (result) {
                  var pngSrcset = [],
                    webpSrcset = [],
                    regex = /^(\d+)x(\d+)$/;

                  if (result.success) {
                    angular.forEach(result.images, function (image) {
                      var matches = image.resolution.match(regex);
                      var width = matches[1];

                      if (image.fileType === "webp") {
                        webpSrcset.push(
                          $filter("formatArgs")("{0} {1}w", [image.url, width])
                        );
                      } else if (image.fileType === "png") {
                        pngSrcset.push(
                          $filter("formatArgs")("{0} {1}w", [image.url, width])
                        );
                      }
                    });

                    $scope.pricingImage.showImage = true;
                    var webpScrsetString = webpSrcset.join(", ");
                    var pngScrsetString = pngSrcset.join(", ");

                    if (
                      $scope.image.pngSrcset === pngScrsetString ||
                      $scope.image.webpSrcset === webpScrsetString
                    ) {
                      hideLoadingOverlay();
                    } else {
                      $scope.image.webpSrcset = webpScrsetString;
                      $scope.image.pngSrcset = pngScrsetString;

                      $image.one("load error", function () {
                        hideLoadingOverlay();
                        $scope.$apply();
                      });

                      $timeout(function () {
                        picturefill({ reevaluate: true });
                      });
                    }
                  } else {
                    $scope.pricingImage.showImage = false;
                    hideLoadingOverlay();
                  }
                }
              },
              function () {
                $scope.pricingImage.showImage = false;
                hideLoadingOverlay();
              }
            );
          };

          ctl.setTfyCookie = function () {
            Tfy.cacheMaterialCodeAndUpdateCookie(
              Tfy.getCurrentPageVehicleModel()?.tfyModelName,
              $scope.pricingImage.materialCode
            );
          };

          function loadingOverlay() {
            $scope.pricingImage.loading = true;
            $loadingOverlay.addClass("is-loading");
          }

          function hideLoadingOverlay() {
            $scope.pricingImage.loading = false;
            $loadingOverlay.removeClass("is-loading");
          }
        },
      ];

      return {
        scope: false,
        restrict: "A",
        controller: controller,
        bindToController: true,
        controllerAs: "pricingImageController",
        link: function (scope) {
          scope.image = {};

          scope.pricingImageController.updateImage();
        },
      };
    },
  ]);
})(window.angular, window.picturefill, window.ToyotaConsts);
